import { render, staticRenderFns } from "./comp_CategoriesMegaMenu-CategoryTitle.vue?vue&type=template&id=7624468f&scoped=true"
import script from "./comp_CategoriesMegaMenu-CategoryTitle.vue?vue&type=script&lang=js"
export * from "./comp_CategoriesMegaMenu-CategoryTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7624468f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
